<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>个人中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="-5"></centerLeft>
				<div class="center-right">
					<div class="title">修改密码</div>
					
					<div class="step-one" v-if="step == 1">
						<el-form :model="ruleForm" :rules="rules" ref="threeForm" label-width="120px">
						  <el-form-item label="旧密码" prop="oldPassword">
								<el-input v-model="ruleForm.oldPassword" type="password" placeholder="请输入旧密码"></el-input>
						  </el-form-item>
						  <el-form-item label="新的密码" prop="password">
								<el-input v-model="ruleForm.password" type="password" placeholder="设置6至20位登录密码"></el-input>
						  </el-form-item>
						  <el-form-item label="重置密码" prop="samePassword">
								<el-input v-model="ruleForm.samePassword" type="password" placeholder="设置6至20位登录密码"></el-input>
						  </el-form-item>
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="isSubmit" @click="threeSubmit()">下一步</el-button>
					</div>
					
					<div v-if="step == 2">
						<div class="register-three">
							<img src="@/assets/images/dui.png"/>
							<div class="register-three-title">密码设置成功</div>
							<div class="register-three-desc"></div>
							<div class="register-three-button" @click="toLast">重新登录</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import {updatePassword} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	data(){
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.password) {
			  callback(new Error('两次输入密码不一致!'));
			} else {
			  callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入密码'));
			  
			} else if (!/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.]{6,20}$/.test(value)) {
			  callback(new Error('密码必须是6-20位、必须含有字母、数字!'));
			} else {
			  callback();
			}
		};
		return {
			step:1,
			ruleForm:{
				oldPassword:"",
				password:"",
				samePassword:"",
			},
			
			rules:{
				password: [
					{ validator: validatePass, trigger: 'blur' }
				],
				samePassword: [
					{ validator: validatePass2, trigger: 'blur' }
				],
				oldPassword:[
					{ required: true, message: '请输入旧密码', trigger: 'blur' },
				]
			},
			isSubmit:false
		}
	},
	methods:{
		//第三步提交数据
		threeSubmit(){
			this.$refs['threeForm'].validate((valid) => {
				if (valid) {
					this.isSubmit = true;
					updatePassword(this.ruleForm).then(res=>{
						if(res.code == 1000){
							this.step = 2;
							this.$cookies.set('userToken', "");
						}else{
							this.isSubmit = false;
							return this.$message.error(res.message);
						}
					})
				}
			});
		},
		toLast(){
			this.$router.replace("/login");
		}
	}
}
</script>

<style lang="scss" scoped>
	.msg-notice{
		height: 22px;
		font-weight: 400;
		font-size: 14px;
		color: #E91A12;
		line-height: 22px;
		width: 220px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: -232px;
		margin-top: -11px;
	
	}
	.send-code{
		height: 22px;
		font-weight: 400;
		font-size: 16px;
		color: rgba(233, 26, 18, 1);
		line-height: 22px;
		width: 120px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: 0px;
		margin-top: -11px;
		cursor: pointer;
	}
	.step-one{
		width: 540px;
		margin: 0 auto;
		::v-deep .el-form-item__label{
			font-size: 16px;
			color: #9E9E9E;
			&::before{
				display: none;
			}
		}
		::v-deep .el-input__inner{
			width: 420px;
			height: 48px;
			border: 1px solid rgba(7, 11, 19, 0.1);
		}
		.image-show{
			margin: 0px 0px 40px 120px;
			img{
				width: 96px;
				height: 40px;
				object-fit: contain;
			}
			div{
				font-size: 16px;
				line-height: 22px;
				color: #9E9E9E;
				cursor: pointer;
				margin-left: 16px;
				span{
					color: #E91A12;
				}
			}
		}
		.login-button{
			margin-left: 120px;
			width: 420px;
			height: 46px;
			background: #E91A12;
			font-size: 16px;
			font-weight: 500;
			color: #FFFFFF;
			border: 0px;
			margin-top: 20px;
		}
	}
	.forget-step{
		margin-bottom: 40px;
		.forget-step-dian{
			padding: 0px 15px;
			span{
				width: 4px;
				height: 4px;
				background: #E8E8E8;
				border-radius: 100%;
				display: block;
				margin: 0px 5px;
			}
			.active{
				background: rgba(233, 26, 18, 1);
			}
		}
		.forget-step-active{
			img{
				width: 28px;
				height: 28px;
				margin-right: 12px;
				flex: 0 0 28px;
			}
			div{
				font-size: 16px;
				line-height: 24px;
				color: #1D2129;
			}
		}
		.forget-step-item{
			div{
				&:first-of-type{
					width: 28px;
					height: 28px;
					border-radius: 14px;
					background: #F2F3F5;
					margin-right: 12px;
					flex: 0 0 28px;
					font-size: 16px;
					line-height: 28px;
					color: #4E5969;
					text-align: center;
				}
				&:last-of-type{
					font-size: 16px;
					line-height: 24px;
					color: rgba(78, 89, 105, 1);
				}
			}
		}
	}
	.forget-title{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #070B13;
		padding: 20px 40px 60px;
	}
	.register-three{
		text-align: center;
		padding-top: 30px;
		img{
			width: 64px;
			height: 64px;
		}
		.register-three-title{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 20px;
		}
		.register-three-button{
			width: 260px;
			height: 46px;
			border: 1px solid rgba(233, 26, 18, 0.1);
			font-size: 16px;
			font-weight: 500;
			line-height: 46px;
			text-align: center;
			color: #070B13;
			margin: 40px auto 0px;
			cursor: pointer;
		}
	}
	.title{
		font-size: 16px;
		font-weight: 500;
		line-height: 64px;
		color: #070B13;
		margin-bottom: 100px;
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
